module.exports = __webpack_public_path__ + "media/images/locations-banner-469e4bdf.jpg";